import type { MjParams, PromptDocument, Section } from '../types'
import { sanitizeMjParams } from '../factory'
import type { PlatformRenderer } from './index'

/**
 * Collect enabled sections in display order, stripping empties.
 */
function collectEnabledSections(doc: PromptDocument): Section[] {
  return doc.sections
    .filter(s => s.enabled && s.tags.some(t => t.raw.trim()))
    .slice()
    .sort((a, b) => a.order - b.order)
}

function sectionToLine(s: Section): string {
  return s.tags
    .map(t => t.raw.trim())
    .filter(Boolean)
    .join(', ')
}

function paramsToString(p: MjParams): string {
  const clean = sanitizeMjParams(p)
  const parts: string[] = []
  if (clean.ar)
    parts.push(`--ar ${clean.ar}`)
  if (clean.v)
    parts.push(`--v ${clean.v}`)
  if (clean.style)
    parts.push(`--style ${clean.style}`)
  if (clean.q !== undefined)
    parts.push(`--q ${clean.q}`)
  if (clean.s !== undefined)
    parts.push(`--s ${clean.s}`)
  if (clean.chaos !== undefined)
    parts.push(`--chaos ${clean.chaos}`)
  if (clean.no && clean.no.length)
    parts.push(`--no ${clean.no.join(', ')}`)
  return parts.join(' ')
}

export const midjourneyRenderer: PlatformRenderer = {
  id: 'midjourney',
  label: 'Midjourney',
  render(doc) {
    const lines = collectEnabledSections(doc).map(sectionToLine).filter(Boolean)
    const params = paramsToString(doc.params)
    const body = lines.join(', ')
    return params ? (body ? `${body} ${params}` : params) : body
  },
}

export { paramsToString as renderMjParams }
